module.exports = __webpack_public_path__ + "static/media/james.94a52150.jpg";